import { createRequestFields, createInitialFormData } from "src/models/common/form_modal";
import { Shipment } from "./shipment.model";
import { Pagination } from "src/models/common/table_main";

export interface ShipmentRequest {
    salesOrganization: string;
    division: string;
    customer: string;
    distributionChannel: string;
    soldTo: string;
    soldToName: string;
    addressCodeSoldTo: string;
    addressSoldTo: string;
    shipTo: string;
    shipToName: string;
    address: string;
    codeShipTo: string;
    addressShipTo: string;
    partnerFunction: string;
    partnerCounter: string;
    vendor: string;
    personnelNumber: string;
    contactPerson: string;
    partnerDesc: string;
    defaultPartner: string;
    createdBy?: string;
    updatedBy?: string;
  }
  
  export interface SubmitRequest {
    importItems: Array<ShipmentRequest>;
    userId: string;
  }
  
  export interface ShipmentState {
    data: Shipment[] | null;
    pagination: Pagination | null;
    loading: boolean;
    error: boolean;
    errorMessage: string;
  }
  
  export const shipmentInitialState: ShipmentState = {
    data: null,
    pagination:null,
    loading: false,
    error: false,
    errorMessage: null,   
  };
  
  // Ini untuk Form Add / Update 
  export const shipmentRequest = createRequestFields<Shipment>([
    { label: 'Sales Organization', name: 'salesOrganization', dataType:'string' },
    { label: 'Division', name: 'division', dataType:'string' },
    { label: 'Customer', name: 'customer' , dataType:'string'},
    { label: 'Distribution Channel', name: 'distributionChannel' , dataType:'string'},
    { label: 'Sold To', name: 'soldTo', dataType:'string' },
    { label: 'Sold To Name', name: 'soldToName', dataType:'string' },
    { label: 'Address Code Sold To', name: 'addressCodeSoldTo', dataType:'string' },
    { label: 'Address Sold To', name: 'addressSoldTo', dataType:'string' },
    { label: 'Ship To', name: 'shipTo', dataType:'string' },
    { label: 'Ship To Name', name: 'shipToName' , dataType:'string'},
    { label: 'Address', name: 'address' , dataType:'string'},
    { label: 'Code Ship To', name: 'codeShipTo', dataType:'string' },
    { label: 'Address Ship To', name: 'addressShipTo' , dataType:'string'},
    { label: 'Partner Function', name: 'partnerFunction', dataType:'string' },
    { label: 'Partner Counter', name: 'partnerCounter' , dataType:'string'},
    { label: 'Vendor', name: 'vendor' , dataType:'string'},
    { label: 'Personal Number', name: 'personnelNumber', dataType:'string' },
    { label: 'Contact Person', name: 'contactPerson' , dataType:'string'},
    { label: 'Partner Desc', name: 'partnerDesc', dataType:'string' },
    { label: 'Default Partner', name: 'defaultPartner', dataType:'string' },
  ]);
  
  export const initialShipmentFormData = createInitialFormData<Shipment>(shipmentRequest);
  